import { useCallback, useEffect, useState } from "react";
import { unwrapResult } from "@reduxjs/toolkit";
import ReactGA from 'react-ga4';
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import './checkout.scss';
import CustomButton from "../../uiKit/Button/CustomButton";

import {
    campaignPaymentIntent,
    campaignPaymentIntentSaved,
} from "../../redux/state/paymentSlice";
import { setCampaignThankOpen, setStripeOpen } from "../../redux/state/donationSlice";

const CampaignCheckout = () => {
    const dispatch = useDispatch();
    const { pathname } = useLocation();
    const { campaignId, communityId } = useParams();

    const [isLoading, setIsLoading] = useState(false);

    const savedCard = useSelector(state => state.payment.savedCard, shallowEqual);
    const body = useSelector(state => state.donation.body, shallowEqual);
    const isLoadingCampaignIntent = useSelector(state => state.payment.isLoading.campaignPaymentIntent, shallowEqual);
    const error = useSelector(state => state.payment.error, shallowEqual);

    useEffect(() => {
        if (!!error?.errors?.Amount) {
            toast.info(error.errors.Amount[0] ?? 'something went wrong');
        }
    }, [error])

    useEffect(() => {
        if (!communityId || !campaignId || !body.incomingBalanceId) return;
        dispatch(campaignPaymentIntent({
            body,
            communityId,
            campaignId,
        }))
    }, [body, communityId, campaignId, dispatch])

    const payWithSavedCard = useCallback(() => {
        ReactGA.event(`donate_${pathname.split('/')[1].replace('-', '_')}_with_saved_card_checkout`);
        setIsLoading(true);
        dispatch(campaignPaymentIntentSaved({
            communityId,
            campaignId,
            paymentMethodId: savedCard.id,
            body: body
        }))
            .then(unwrapResult)
            .then((response) => {
                if (response.status === 'Success') {
                    dispatch(setStripeOpen(false));
                    dispatch(setCampaignThankOpen(true));
                }
                else {
                    toast.info(response.title ?? response.errorMessage ?? 'Something went wrong.')
                }
            })
            .catch(({ title }) => {
                toast.info(`Payment failed: ${title}`)
            })
            .finally(() => setIsLoading(false))
    }, [dispatch, savedCard, communityId, campaignId, body, pathname]);

    return (
        <CustomButton
            title='Donate'
            onClick={payWithSavedCard}
            style={{ marginTop: '16px' }}
            disabled={isLoading || isLoadingCampaignIntent}
            loading={isLoading || isLoadingCampaignIntent}
        />
    )
}

export default CampaignCheckout;